import { useFormikContext } from 'formik';
import { useEffect, useRef } from 'react';
import dayjs from 'dayjs';

const AllDayAutoFillEffect = () => {
  const { values, setFieldValue, setFieldError, setFieldTouched } = useFormikContext<any>();
  const prevAllDayRef = useRef<boolean | null>(null);

  useEffect(() => {
    const today = dayjs();

    if (values.allDay && !prevAllDayRef.current) {
      // All Day was just enabled
      if (!values.fromDate) setFieldValue('fromDate', today.startOf('day'));
      if (!values.toDate) setFieldValue('toDate', today.startOf('day'));

      setFieldValue('fromTime', today.startOf('day'));
      setFieldValue('toTime', today.endOf('day'));

      setFieldError('fromDate', undefined);
      setFieldError('toDate', undefined);
      setFieldError('fromTime', undefined);
      setFieldError('toTime', undefined);

      setFieldTouched('fromDate', false);
      setFieldTouched('toDate', false);
      setFieldTouched('fromTime', false);
      setFieldTouched('toTime', false);
    }

    if (!values.allDay && prevAllDayRef.current) {
      // All Day was just disabled
      setFieldValue('fromDate', null);
      setFieldValue('toDate', null);
      setFieldValue('fromTime', null);
      setFieldValue('toTime', null);
    }

    // Update the previous value
    prevAllDayRef.current = values.allDay;
  }, [values.allDay]);

  return null;
};

export default AllDayAutoFillEffect
